// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yhHh","left":"styles_left__3qQA7"};